import { compareItems } from "@/mocks/home";
import Reveal from "./Reveal";

export default function CompareSection() {
  return (
    <section id="compare" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <Reveal className="mb-8 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs tracking-[0.35em] text-primary-600">COMPARE</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              图文对比 · 并排拆解
            </h2>
          </div>
          <p className="max-w-md font-body text-sm leading-relaxed text-foreground-600">
            把两类材料放进同一个画幅，差异处就是最值得细读的地方。
          </p>
        </Reveal>

        <Reveal className="grid grid-cols-1 items-stretch gap-3 md:grid-cols-[1fr_auto_1fr] md:gap-0">
          <div className="overflow-hidden rounded-lg border border-background-300 bg-background-50 md:rounded-r-none">
            <div className="relative h-[220px] w-full overflow-hidden bg-background-200 md:h-[300px]">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20representation%20of%20anonymous%20chat%20records%20as%20blank%20rounded%20message%20bubbles%20floating%20on%20warm%20beige%20paper%2C%20muted%20rust%20and%20charcoal%20tones%2C%20soft%20calm%20light%2C%20minimal%20background%2C%20subtle%20grain%2C%20no%20readable%20text%2C%20no%20logos%2C%20no%20people%2C%20refined%20magazine%20illustration%2C%20quiet%20analytical%20mood%2C%20high%20detail&width=800&height=800&seq=hl-compare-a&orientation=squarish"
                alt="黑料图文图文对比：聊天记录侧"
                title="黑料图文图文对比 聊天记录"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="p-4 md:p-5">
              <span className="rounded-full bg-secondary-100 px-3 py-1 font-label text-xs text-secondary-900">
                材料 A
              </span>
              <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">聊 天 记 录</h3>
              <p className="mt-2 font-body text-sm leading-relaxed text-foreground-600">
                私域对话里的措辞温度与回复间隔，往往比公开表达更早出现松动。
              </p>
            </div>
          </div>

          <div className="flex items-center justify-center py-2 md:w-[70px] md:py-0">
            <span className="flex h-11 w-11 items-center justify-center rounded-full border border-background-300 bg-background-50 font-heading text-sm font-bold text-primary-600">
              对
            </span>
          </div>

          <div className="overflow-hidden rounded-lg border border-background-300 bg-background-50 md:rounded-l-none">
            <div className="relative h-[220px] w-full overflow-hidden bg-background-200 md:h-[300px]">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20representation%20of%20public%20posts%20as%20blank%20stacked%20social%20cards%20on%20a%20warm%20cream%20desk%2C%20muted%20amber%20and%20charcoal%20tones%2C%20soft%20calm%20daylight%2C%20minimal%20background%2C%20subtle%20film%20grain%2C%20no%20readable%20text%2C%20no%20logos%2C%20no%20people%2C%20refined%20magazine%20illustration%2C%20quiet%20analytical%20mood%2C%20high%20detail&width=800&height=800&seq=hl-compare-b&orientation=squarish"
                alt="黑料图文图文对比：公开动态侧"
                title="黑料图文图文对比 公开动态"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="p-4 md:p-5">
              <span className="rounded-full bg-accent-100 px-3 py-1 font-label text-xs text-accent-800">
                材料 B
              </span>
              <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">公 开 动 态</h3>
              <p className="mt-2 font-body text-sm leading-relaxed text-foreground-600">
                公开发布的时间差、配图选择与互动节奏，暴露了传播的先后次序。
              </p>
            </div>
          </div>
        </Reveal>

        <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3">
          {compareItems.map((item, index) => (
            <Reveal key={item.label} delay={index * 80}>
              <div className="flex h-full gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                <span className="font-heading text-2xl font-bold text-background-400">{`0${index + 1}`}</span>
                <div>
                  <span className="font-label text-xs text-foreground-400">{item.note}</span>
                  <h4 className="font-heading text-base font-bold text-foreground-950">{item.label}</h4>
                  <p className="mt-1 font-body text-sm leading-relaxed text-foreground-600">{item.caption}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}